module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4110@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4110%402x.png
// module id = fB6N
// module chunks = 93